import { AddressForm, AddressTypeCode } from '../../../global-types/addresses';
import { saveAddress, saveAddresses, saveQuickAddress } from '../../../services/address';
import { formatAddress } from './format-address';

export const handleAddressSubmitOneToMany = async (project_id: string, payload: AddressForm | AddressForm[]) => {
  if (Array.isArray(payload)) {
    const formattedAddresses = payload.map((data) => {
      const address = formatAddress(data);

      return {
        address,
        is_verified: data.skip_usps_validation,
      };
    });

    return saveAddresses(project_id, { addresses: formattedAddresses, skip_ebdw_validation: true });
  }

  if (payload.isQuickAddress) {
    await saveQuickAddress({
      ...formatAddress(payload),
      skip_address_verification: true,
      contact_type_code: 'A',
    });
  }

  return saveAddress(project_id, {
    ...formatAddress(payload),
    skip_usps_validation: payload.skip_usps_validation,
    address_type_code: AddressTypeCode.RECIPIENT,
  });
};
